exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coupon-area[data-v-4a84ff3a] {\n  background-color: white;\n  border: 1px solid #dee2e6;\n  border-radius: 10px;\n  padding: 0.75rem;\n}\n.coupon-area__input[data-v-4a84ff3a] {\n  max-width: 280px;\n  display: inline-block;\n}\n.coupon-area__button[data-v-4a84ff3a] {\n  margin-left: 0.5rem;\n}\n.empty-cart[data-v-4a84ff3a] {\n  font-size: 80px;\n  color: lightgray;\n}\n@media (max-width: 767px) {\n.coupon-area__input[data-v-4a84ff3a] {\n    max-width: 100%;\n    display: inline-block;\n}\n.coupon-area__button[data-v-4a84ff3a] {\n    width: 100%;\n    margin-left: 0;\n    margin-top: 0.75rem;\n}\n}", ""]);

// exports
